










































import {
  defineComponent,
  useFetch,
  useContext,
  useRoute,
  computed,
  ref
} from '@nuxtjs/composition-api';
import { usePartFinderStore } from '~/modules/part-finder/stores/partFinder';
import { storeToRefs } from 'pinia';
import { SfBreadcrumbs, SfHeading } from '@storefront-ui/vue';
import SkeletonLoader from 'components/theme/SkeletonLoader.vue';

export default defineComponent({
  name: 'Brands',
  components: {
    SfBreadcrumbs,
    SfHeading,
    SkeletonLoader
  },
  setup () {
    const store = usePartFinderStore();
    const { loadFinders, setFinder } = store;
    const { finders, selectedFinder, findersLoading, brands, brandsLoading } = storeToRefs(store);

    const { app: { i18n, localeRoute } } = useContext();
    const breadcrumbs = ref([
      { text: i18n.t('Home'), link: localeRoute({ name: 'home' }).fullPath },
      { text: i18n.t('part-finder.spare-parts'), link: localeRoute({ name: 'part-finder' }).fullPath }
    ]);

    const route = useRoute();

    const title = computed<string>(() => {
      return selectedFinder.value ? selectedFinder.value.name : i18n.t('part-finder.spare-parts');
    });

    useFetch(async() => {
      if (!finders.value.length) {
        await loadFinders();
      }
      const finder = finders.value.find(f => f.slug === route.value.params.finder);
      if (finder) {
        await setFinder(finder);
        breadcrumbs.value.push({
          text: finder.name,
          link: localeRoute({ name: 'part-finder-finders', params: { finder: finder.slug } }).fullPath
        })
      }
    })

    return {
      title,
      breadcrumbs,
      brands,
      brandsLoading,
      selectedFinder,
      findersLoading
    }
  },
  head () {
    return {
      title: String(this.title)
    }
  }
})
